var _defs, _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportSubmissionXml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M39.31 23.15V12.06l-7.16-7.21H21.12c-3.13 0-5.68 2.54-5.68 5.68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M31.27 4.84v8.07h8.04M15.03 16.57l5.48 5.48-5.48 5.48M19 22.05l-11.79.03"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 2.47,
    cy: 22.02,
    r: 1.44
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M24.62 37.58l-3.94-4.94 4.22-5.22M31.86 25.65l-3.24 13.69M35.85 27.42l3.94 4.94-4.22 5.22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportSubmissionXml);
export default __webpack_public_path__ + "static/media/exportSubmissionXML.e4bc87a857bf5f31490c5016dbf13812.svg";
export { ForwardRef as ReactComponent };